import { FC } from 'react';
import { NewDraftReleaseButton } from './NewDraftReleaseButton';
import { useReleasePageContext } from './context/useReleasePageContext';

export const ReleaseCardAction: FC = () => {
  const { releases } = useReleasePageContext();

  return <>{!!releases.length && <NewDraftReleaseButton />}</>;
};
